import type { ValueOf } from './util/typeUtils';

export const STUCK_JOB_TYPES = {
    CHECK_FAILED: 'CHECK_FAILED',
    JOB_EXCEEDING_TIMEOUT: 'JOB_EXCEEDING_TIMEOUT',
    NO_JOBS_BEING_PROCESSED: 'NO_JOBS_BEING_PROCESSED',
    QUEUE_CHECK_FAILED: 'QUEUE_CHECK_FAILED',
    QUEUE_NOT_INITIALIZED: 'QUEUE_NOT_INITIALIZED',
    QUEUE_PAUSED: 'QUEUE_PAUSED',
    REDIS_CONNECTION_FAILED: 'REDIS_CONNECTION_FAILED',
    WORKER_CHECK_FAILED: 'WORKER_CHECK_FAILED',
    WORKER_NOT_INITIALIZED: 'WORKER_NOT_INITIALIZED',
    WORKER_PAUSED: 'WORKER_PAUSED',
} as const;

export const EVENT_CALLBACK_STATES = {
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    PROCESSING: 'PROCESSING',
    TIMEOUT: 'TIMEOUT',
} as const;

export type EVENT_CALLBACK_STATE = ValueOf<typeof EVENT_CALLBACK_STATES>;

export const COMMAND_CONFLICT_MESSAGES = {
    EVENTS_OVERLAPPED: 'Events overlapped',
} as const;
